// extracted by mini-css-extract-plugin
export var dividerLine = "_6o-3";
export var itemImage = "_6o-9";
export var lightDivider = "_6o-4";
export var modalContent = "_6o-5";
export var modalContentCompact = "_6o-6";
export var productCard = "_6o-a";
export var productImage = "_6o-b";
export var productImageCompact = "_6o-7";
export var productImagePlaceholder = "_6o-c";
export var productImagePlaceholderCompact = "_6o-8";
export var progressBarBackground = "_6o-1";
export var progressBarContainer = "_6o-0";
export var progressBarFill = "_6o-2";